<template>
    <div class="carefullyChosenCon">
        <div v-for="item in classList" :key="item.code">
            <div class="head">
                <div>
                    <div></div>
                    <p>{{ item.name }}</p>
                </div>
                <div @click="goClass(item)">更多</div>
            </div>
            <ul>
                <li v-for="(bookItem, index) in item.bookList" :key="index" class="bookList_book_style" @click="goBook(bookItem.id)" :title="bookItem.name">
                    <dl>
                        <dt>
                            <img :src="bookItem.cover" alt="">
                            <div>
                                <div></div>
                                <p>{{ bookItem.plays }}</p>
                            </div>
                        </dt>
                        <dd>
                            <p>{{ bookItem.name }}</p>
                            <p>{{ bookItem.author }}</p>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            classList: []
        }
    },
    mounted (){
        let that = this;
        that.choiceList();
    },
    methods: {
        choiceList() {
            let that = this;

            that.allApi.classList().then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.classList = resource.data.data;
                    that.getClassBook();
                }
            })
        },
        choiceBook(idx) {
            let that = this;
            let data = {
                clazz: that.classList[idx].id,
                page: 1,
                size: 6
            }

            that.allApi.bookList(data).then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.$set( that.classList[idx], "bookList", resource.data.data.list );
                }
            })
        },
        getClassBook() {
            let that = this;
            for( let i=0; i<that.classList.length; i++ ) {
                that.choiceBook(i);
            }
        },
        goClass(item) {
            let that = this;

            that.$router.push({
                path: '/classBook',
                query: {
                    id: item.id,
                    name: item.name
                }
            });
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum(bookId);
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
        },
        addClickNum(bookId) {
            let that = this;
            let data = {
                book: bookId
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        }
    },
    watch: {

    }
}
</script>

<style lang="scss" scoped>
    .carefullyChosenCon{
        width: 100%;
        overflow: hidden;
        >div{
            margin-bottom: 45px;
            >.head{
                overflow: hidden;
                margin-bottom: 36px;
                >div:first-child{
                    float: left;
                    overflow: hidden;
                    >div{
                        background: #1AA7E0;
                        width: 10px;
                        height: 34px;
                        border-radius: 5px;
                        float: left;
                        margin-right: 18px;
                    }
                    >p{
                        float: left;
                        line-height: 34px;
                        @include dominant_color(#1c1c1c);
                        font-size: 26px;
                        font-weight: 500;
                    }
                }
                >div:last-child{
                    float: right;
                    line-height: 34px;
                    color: #363636;
                    cursor: pointer;
                }
            }
            >ul{
                display: flex;
                // justify-content: space-around;
                >li{
                    width: 145px;
                    cursor: pointer;
                    margin-right: 66px;
                    &:nth-child(6n){
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
